import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../../Redux/Actions/userActions";

// Component Imports
import OrderSearchForm from "./OrderSearchWidget/OrderSearchForm";
import OrderSearchTableWidget from "./OrderSearchTableWidget/OrderSearchTableWidget";

// CSS Imports
import "./SearchStyles.css";

const OrderSearch = ({ isOpen }) => {
  const [orderResults, setOrderResults] = useState([]);
  const [prefillData, setPrefillData] = useState(null)
  const [initRender, setInitRender] = useState(true);
  const [loading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      const res = await fetch(`/api/auth/get-auth`, {
        method: "GET",
        credentials: "include",
      });
      if (res.status === 401) {
        dispatch(logout());
        return navigate("/");
      }else {
        const previousSearchResults = localStorage.getItem('previousSearchResults');
        if(previousSearchResults) {
          const { bodyParams, result }= JSON.parse(previousSearchResults);
          const parsedBody = JSON.parse(bodyParams);
          const prefills = {};
          for(const [entry, value] of Object.entries(parsedBody)) {
            if(value) prefills[entry] = value;
          }
          setPrefillData(prefills)
          setOrderResults(result)
        }
      }
    })();
  }, [dispatch, navigate ]);


  const searchOrders = async (
    phone,
    email,
    firstName,
    lastName,
    firstSix,
    lastFour,
    cardTypeId,
    city,
    zip,
    customerId,
    brandId,
    orderId,
    state,
    orderStatusId,
    startDate,
    endDate,
    membershipEmail,
    scn,
    sca,
    ipAddress,
    includeInactiveCustomers
  ) => {
    setIsLoading(true)
    const options = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        phone: +phone?.match(/\d/g)?.join("") || "",
        email,
        firstName,
        lastName,
        firstSix,
        lastFour,
        cardTypeId,
        city,
        postalCode: zip,
        customerId,
        brandId,
        orderId,
        state,
        orderStatusId,
        startDate,
        endDate,
        membershipEmail,
        scn,
        sca,
        ipAddress,
        includeInactiveCustomers
      }),
    };
    const res = await fetch("/api/orders/search", options);
    setIsLoading(false)

    if (res.status === 401) {
      dispatch(logout());
      return navigate("/");
    }
    const { result } = await res.json();
    localStorage.setItem('previousSearchResults', JSON.stringify({result, bodyParams: options.body}))
    setOrderResults(result);
  };

  const onHandleSubmit = (
    phone,
    email,
    firstName,
    lastName,
    firstSix,
    lastFour,
    cardTypeId,
    city,
    zip,
    customerId,
    brandId,
    orderId,
    state,
    orderStatusId,
    startDate,
    endDate,
    membershipEmail,
    scn,
    sca,
    ipAddress,
    includeInactiveCustomers
  ) => {
    searchOrders(
      phone,
      email,
      firstName,
      lastName,
      firstSix,
      lastFour,
      cardTypeId,
      city,
      zip,
      customerId,
      brandId,
      orderId,
      state,
      orderStatusId,
      startDate,
      endDate,
      membershipEmail,
      scn,
      sca,
      ipAddress,
      includeInactiveCustomers
    );
    setInitRender(false);
  };
  return (
    <div className={`${isOpen ? "page" : "page-closed"} container`}>
      <h3 className="heading">Search Customers and Orders</h3>
      <OrderSearchForm
        onClick={onHandleSubmit}
        prefillData={prefillData}
        setPrefillData = {setPrefillData}
      />
      <OrderSearchTableWidget
        orderResults={orderResults}
        initRender={initRender}
        loading={loading}
      />
    </div>
  );
};

export default OrderSearch;
